<template>
    <div class="loader"></div>
</template>

<style lang="scss">
.loader {
    width: inherit;
    height: inherit;
    border: 3px solid var(--primary-colour-1);
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 
</style>